module.exports = __webpack_public_path__ + "img/stock1.9fb4e370.png";